module.exports = __webpack_public_path__ + "media/home2.c423d16e.mp4";